export default __webpack_public_path__ + "static/media/photo2.554a953a.png";